import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Global } from '@emotion/core';
import { SiteContext } from '../contexts/site';
import Header from './site-header/site-header';
import Footer from './site-footer/site-footer';
import SiteNavigationWrapper from './site-navigation/site-navigation';
import FeaturedNavigation from './featured-navigation/featured-navigation';
import avertaRegular from '../fonts/Averta-Regular.woff2';
import avertaBold from '../fonts/Averta-Bold.woff2';
import { colors } from '../gatsby-plugin-theme-ui';
import Overlay from './site-header/overlay';

const Layout = ({ children }) => {
  const { primaryNavOpen } = useContext(SiteContext);
  return (
    <>
      <Global styles={{
        '@font-face': {
          fontFamily: 'Averta',
          fontStyle: 'normal',
          fontWeight: 400,
          fontDisplay: 'swap',
          src: `url(${avertaRegular}) format('woff2')`,
        },
      }}
      />
      <Global styles={{
        '@font-face': {
          fontFamily: 'Averta',
          fontStyle: 'normal',
          fontWeight: 700,
          fontDisplay: 'swap',
          src: `url(${avertaBold}) format('woff2')`,
        },
      }}
      />
      <Global styles={{
        html: {
          fontSize: '10px',
          scrollBehavior: 'smooth',
          backgroundColor: colors.SecondaryGray3,
        },
        body: {
          backgroundColor: 'White',
        },
      }}
      />
      {/* <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      </Helmet> */}
      <Header />
      {primaryNavOpen && <Overlay />}
      {children}
      <FeaturedNavigation />
      <SiteNavigationWrapper />
      <Footer />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Layout;
